import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ben-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})

export class ButtonComponent implements OnInit {
  @Input() workInProgress: boolean = false;
  @Input() buttonText: string = 'ok';
  @Input() isSecondary: boolean = false;
  @Output() buttonClickedEvent = new EventEmitter<string>();
  buttonType: string;

  ngOnInit(): void {
    this.buttonType = this.isSecondary ? "secondary-button" : "primary-button";
  }

  onButtonClicked() {
    this.buttonClickedEvent.emit("button pressed");
  }
}
